import React from 'react'
import styles from '../styles/Navbar.module.css'

interface CoverProps {
  imagePath: string;
  textOnImage: string;
}

const Cover: React.FC<CoverProps> = ({imagePath, textOnImage}) => {

  return (
    <div className={styles.coverContainer}>
      <img src={imagePath} alt='cover' className={styles.cover} />
      <div className={styles.centeredText}>{textOnImage}</div>
    </div>
  )
}

export default Cover